const mEditionBillingMyPaymentsDropDownFilters = {
  mEditionBillingMyPaymentsDropDownFilters: {
    input: {
      estado: {
        label: 'Estados de Pagos'
      },

      divisa: {
        label: 'Monedas'
      },

      medioPago: {
        label: 'Medios de Pago'
      },

      fechaDesde: {
        label: 'Fecha Desde',
        placeholder: 'Desde - DD MM, AAAA'
      },

      fechaHasta: {
        label: 'Fecha Hasta',
        placeholder: 'Hasta - DD MM, AAAA'
      },

      descuento: {
        label: 'Código de Descuento',
        placeholder: 'Escribe aquí un código'
      }
    },

    buttons: {
      btnReiniciarText: 'ACTUALIZAR',
      btnFilterText: 'FILTRAR'
    }
  }
}

export default mEditionBillingMyPaymentsDropDownFilters
